export const es = {
    store: "Tienda",
    meal: "Comida",
    users: "Usuarios",
    user: "Usuario",
    layout: "Diseño",
    analytics: "Análisis",
    settings: "Configuraciones",
    storeDetails: "Detalles de la tienda",
    advanced: "Avanzado",
    name: "Nombre",
    quantity: "Cantidad",
    address: "Dirección",
    email: "Correo electrónico",
    phone: "Teléfono",
    galleryForCustomer: "Galería/Anuncio para pantalla orientada al cliente",
    customMealCategory: "Categoría de Comida Personalizada",
    storeType: "Tipo de tienda",
    currency: "Moneda",
    add: "Agregar",
    print: "Imprimir",
    sessions: "Sesiones",
    orders: "Pedidos",
    customerFacingScreen: "Pantalla hacia el cliente",
    cashierView: "Vista de cajero",
    kitchenView: "Vista de cocina",
    layoutView: "Vista de diseño",
    history: "Historia",
    noOrderRecordsExist: "No existen registros de pedidos",
    noSessionRecordsExist: "No existen registros de sesiones",
    updateMenu: "Actualizar menú",
    updateMenuSuccessfully: "Menú actualizado con éxito",
    updateMenuTooltip: "Suba el menú más reciente al servidor después de cada modificación a sus comidas",
    serving: "Sirviendo",
    active: "Activo",
    inactive: "Inactivo",
    amount: "Monto",
    total: "Total",
    table: "Mesa",
    payment: "Pago",
    changeDue: "Cambio debido",
    printReceipt: "Imprimir recibo",
    cancel: "Cancelar",
    complete: "Completar",
    edit: "Editar",
    delete: "Eliminar",
    update: "Actualizar",
    deleteOrder: "Eliminar pedido",
    printOrderSlip: "Imprimir comprobante de pedido",
    printKitchenSlip: "Imprimir comprobante de cocina",
    latestOrderAt: "Último pedido en",
    completedAt: "Completado en",
    received: "Recibido",
    startEditing: "Comenzar a editar",
    save: "Guardar",
    addSmallDiningTable: "Agregar mesa de comedor pequeña",
    addMediumDiningTable: "Agregar mesa de comedor mediana",
    addLargeDiningTable: "Agregar mesa de comedor grande",
    clearAll: "Limpiar todo",
    undo: "Deshacer",
    reorder: "Reordenar",
    renew: "Renovar",
    renewSession: "Renovar sesión",
    createNewSession: "Crear nueva sesión",
    addSession: "Agregar sesión",
    createSession: "Crear sesión",
    printSession: "Imprimir código QR",
    takeOrder: "Tomar pedido",
    editOrder: "Editar pedido",
    completeOrder: "Completar pedido",
    description: "Descripción",
    ingredients: "Ingredientes",
    price: "Precio",
    category: "Categoría",
    createdDate: "Fecha de creación",
    lastUpdated: "Última actualización",
    lastUpdatedAt: "Última actualización en",
    admins: "Administradores",
    members: "Miembros",
    invited: "Invitados",
    owner: "Propietario",
    member: "Miembro",
    admin: "Administrador",
    adminsTooltip: "Solo el Super Administrador (dueño de la tienda) puede otorgar y remover el rol de administrador",
    membersTooltip: "El miembro está autorizado solo para ver y gestionar el pedido del cliente.",
    invitedTooltip: "Las personas invitadas recibirán el rol de [Miembro] una vez aceptada la invitación.",
    invitedPeople: "Personas invitadas",
    transferOwnership: "Transferir propiedad",
    removeAdminRole: "Remover rol de administrador",
    grantAdminRole: "Otorgar rol de administrador",
    invitePeople: "Invitar personas",
    addStore: "Agregar tienda",
    alreadyExists: "ya existe",
    existingInvitationTo: "Invitación existente a",
    emailIsRequired: "El correo electrónico es requerido",
    nameIsRequired: "El nombre es requerido",
    priceIsRequired: "El precio es requerido",
    invalidEmailAddress: "Dirección de correo electrónico inválida",
    fullService: "Servicio completo",
    limitedService: "Servicio limitado",
    storeTypeDescription: "Cambiar el tipo de tienda afectará cómo se muestra y completa cada pedido en la vista de cajero.",
    limitedServiceDescription: "El servicio limitado gestiona pedidos como un pedido por envío. (p. ej., quiosco de alimentos/bebidas, patio de comidas)",
    fullServiceDescription: "El servicio completo gestiona pedidos como un pedido por mesa/sesión. (p. ej., restaurante, café)",
    fullServiceExplain: "El servicio completo proporciona una experiencia completa de comedor y los clientes suelen pagar después de comer. (p. ej., restaurante, café)",
    limitedServiceExplain: "El servicio limitado generalmente termina su interacción con el cliente (servicio y pago) antes o en el momento de servir las comidas. (p. ej., quiosco de alimentos/bebidas, patio de comidas)",
    orderIsEmpty: "El pedido está vacío",
    completedByKitchen: "Completado por la cocina",
    changeMealImage: "Cambiar imagen de la comida",
    uploadMealImage: "Subir imagen de la comida",
    food: "Comida",
    drink: "Bebida",
    side: "Acompañamiento",
    submitted: "Enviado",
    confirmDeleteMeal: "¿Confirmar eliminación de la comida?",
    confirmRenewSession: "La sesión aún es válida, ¿confirmar renovación?",
    confirmCompleteOrder: "¿Confirmar completar pedido?",
    confirmDeleteSession: "¿Confirmar eliminación de la sesión?",
    confirmDeleteImage: "¿Confirmar eliminación de la imagen?",
    storeInvitation: "Invitación de tienda",
    noInvitationFound: "No se encontró invitación, por favor solicite autorización del administrador de la tienda",
    join: "Unirse",
    joinStore: "Unirse a la tienda",
    settingUpStore: "Configurando tu tienda",
    createStore: "Crear tienda",
    invitation: "Invitación",
    uploadProfilePicture: "Subir foto de perfil",
    changeProfilePicture: "Cambiar foto de perfil",
    myStores: "Mis tiendas",
    profile: "Perfil",
    accountSettings: "Configuraciones de cuenta",
    signOut: "Cerrar sesión",
    deleteStore: "Eliminar tienda",
    cloneStore: "Clonar tienda",
    uploadImage: "Subir imagen",
    temporarySession: "Sesión temporal (expirará en 24 horas)",
    deleteSessionOnCompletion: "Eliminar sesión al completar el pedido",
    autoRenew: "Renovar automáticamente la sesión al completar el pedido (se requiere eliminar la sesión)",
    limitedServiceSession: "La expiración y eliminación de la sesión han sido deshabilitadas para adaptarse a la operación de servicio limitado, puedes configurar tu preferencia de comportamiento de sesión a continuación",
    noExistingNameFound: "Crear sesión aquí y luego crear mesa en ",
    ifYouWantLink: " para enlazar sesión y mesa en Vista de Diseño",
    noOptions: "Sin opciones",
    addCustomerGallery: "Agregar Galería/Anuncio en Pantalla",
    grantAdminRoleToast: "se le ha otorgado el rol de [Administrador]",
    removeAdminRoleToast: "ha sido movido a la lista de miembros",
    deleteInvitationToast: "ha sido eliminado de la lista de invitaciones",
    deleteMemberToast: "ha sido eliminado de la lista de miembros",
    deleteAdminToast: "ha sido eliminado de la lista de administradores",
    transferOwnershipToast: "transferencia de propiedad de la tienda a",
    sendInvitationToast: "Invitación enviada con éxito a",
    switchedStoreToast: "Cambiado a",
    deleteStoreToast: "Eliminado exitosamente",
    recommendItToCustomer: "Recomendarlo al cliente",
    emailUs: "Envíanos un correo electrónico para cualquier consulta",
    emailUsShort: "Correo electrónico",
    signup: "Registrarse",
    login: "Iniciar sesión",
    quitStore: "Dejar tienda",
    switchToStore: "Cambiar a tienda",
    changeLogo: "Cambiar logo",
    uploadLogo: "Subir logo",
    emailVerifiedToast: "¡Tu correo electrónico ha sido verificado!",
    emailSentToast: "Correo enviado!",
    emailSentToastDescription: "Por favor revisa tu correo para la verificación",
    emailVerificationErrorToast: "Correo de verificación ya enviado",
    emailVerificationFailedToast: "Error al enviar correo de verificación",
    resetPasswordToast: "Gracias, revisa tu correo para instrucciones para restablecer tu contraseña",
    emailNotExist: "El correo no existe",
    failedToUpload: "Falló la carga",
    saveLayoutToast: "Diseño de mesa ha sido actualizado",
    invalidEmailOrPassword: "Correo o contraseña inválidos",
    failedToLogin: "Falló el inicio de sesión",
    verificationEmailSent: "Verificar tu correo electrónico",
    verficiationEmailSentDescription: "Para completar tu proceso de registro debemos verificar que la dirección de correo te pertenece.",
    emailAlreadyExist: "El correo ya existe",
    successfullyCreateStore: "Tienda creada exitosamente",
    pleaseSwitchStore: ", por favor cambia a tu nueva tienda.",
    pleaseCreateMeal: ", por favor procede a crear comidas para tu tienda.",
    youAreNowMemberOf: "Ahora eres miembro de",
    orderFromTable: "Pedido desde la mesa",
    isCompleted: "está completado",
    addedCategory: "Categoría añadida",
    removedCategory: "Categoría eliminada",
    currencyChanged: "Moneda cambiada a",
    successfullyUpdateStore: "Tienda actualizada con éxito",
    storeTypeChanged: "Tipo de tienda cambiado a",
    layoutNotReady: "Diseño no listo...",
    layoutNotReadyDescription: "Aún no has creado tu diseño, por favor procede a crear un diseño para tu tienda.",
    createLayout: "Crear diseño",
    confirmQuitStore: "¿Confirmar salida de la tienda?",
    minimumItemQuantity: "Cantidad mínima decimal de pedido",
    noMoreOrder: "No hay más pedidos",
    loadMore: "Cargar más",
    id: "ID",
    notifications: "Notificaciones",
    noNotificationFound: "No se encontraron notificaciones",
    allowMemberEdit: "Permitir a los miembros editar pedidos",
    storeCreated: "Tienda creada",
    storeCreatedNotification: "Has configurado tu tienda con éxito, por favor procede a crear comidas para tu tienda.",
    manageSubscription: "Gestionar suscripción",
    billing: "Facturación",
    currentSubscription: "Suscripción actual",
    mySubscription: "Mi suscripción",
    initiateSubscription: "Si eres el propietario de una tienda, por favor procede a crear una tienda primero.",
    selectYourStoreType: "Selecciona tu tipo de tienda",
    configureStoreTypeInfo: "El tipo de tienda puede ser reconfigurado más tarde si no estás seguro de cuál elegir.",
    compulsoryItem: "Artículo obligatorio y cantidad inmutable",
    compulsory: "Obligatorio",
    yes: "Sí",
    no: "No",
    hiddenFromMenu: "Oculto del menú",
    dashboard: "Tablero",
    addedPaymentMethod: "Método de pago añadido",
    removedPaymentMethod: "Método de pago eliminado",
    paymentMethod: "Método de pago",
    paymentMethods: "Métodos de pago",
    options: "Opciones",
    summarized: "Resumido",
    unit: "Unidad",
    unitPlaceHolder: "Unidad para propósitos de visualización (p. ej., gramo, kg, conjuntos)",
    totalAmount: "Cantidad total",
    checkout: "Pagar",
    back: "Atrás",
    close: "Cerrar",
    remark: "Observación",
    orderSettings: "Configuraciones de pedido",
    paymentKitchenOrder: "Servir primero / Pagar primero",
    paymentFirst: "Pagar primero",
    servedFirst: "Servir primero",
    alwaysCompleteAtKitchenView: "Para operaciones de Pago Primero, completa tu pedido en la Vista de Cocina cada vez después del pago.",
    paymentFirstWarning: "Seleccionar Pago Primero para Servicio Completo puede causar comportamiento inesperado",
    paymentKitchenExplained: "Selecciona solo la opción de Pago Primero para evitar que el pedido sea removido después del pago. Esto es útil si tu personal necesita leer información en la vista de cocina (p. ej., ingredientes)",
    tableName: "Nombre de mesa / sesión",
    storeOperation: "Operación de tienda",
    sessionControl: "Control de sesión",
    all: "Todo",
    simple: "Simple",
    sessionControlExplained: "Con el control de sesión [Simple] no podrás [Agregar nueva sesión], [Eliminar sesión], [Renovar sesión] y [Imprimir sesión] en [Vista de cajero], así que por favor configura tu configuración de sesión adecuadamente antes de cambiar al control de sesión [Simple].",
    none: "Ninguno",
    nearest: "Más cercano",
    up: "Arriba",
    down: "Abajo",
    roundingTotal: "Redondeo del precio total",
    roundingItem: "Redondeo del precio por artículo",
    changeTo: "Cambiar a",
    allSessionControl: "Control de sesión completo",
    simpleSessionControl: "Control de sesión simple",
    requiredTableName: "Solicitar al personal/cliente que inserte el nombre de la mesa (No relacionado con la mesa del diseño) al pagar",
    pleaseInsertTableName: "Por favor inserta el nombre de tu mesa",
    session: "Sesión",
    inheritFromStore: "Heredado de la tienda",
    customerScreen: "Pantalla del cliente",
    recentOrders: "Pedidos recientes",
    standard: "Estándar",
    standardMenuControl: "Control de menú estándar",
    simpleMenuControl: "Control de menú simple",
    menuControl: "Menú del personal",
    completePaymentFirstAlert: "Por favor completa el pago primero en [Vista de cajero]",
    detail: "Detalle",
    detailNotExists: "El detalle del pedido ya no existe",
    addedRemarkShortcut: "Atajo de observación añadido",
    removedRemarkShortcut: "Atajo de observación eliminado",
    remarkShortcuts: "Atajos de observaciones",
    paymentMethodNameIsRequired: "El nombre del método de pago es requerido",
    paymentMethodAlreadyExisted: "El método de pago ya existía",
    categoryNameIsRequired: "El nombre de la categoría es requerido",
    categoryAlreadyExisted: "La categoría ya existía",
    shortcutNameIsRequired: "El nombre del atajo es requerido",
    shortcutAlreadyExisted: "El atajo ya existía",
    shortcut: "Atajo",
    createOption: "Crear opción",
    optionName: "Nombre de la opción",
    requireChange: "Requiere cálculo de cambio en el pago",
    menuSettings: "Configuraciones de menú",
    paymentSettings: "Configuraciones de pago",
    submittingOrder: "Enviando pedido...",
    submittedOrder: "Pedido enviado con éxito!",
    addMeal: "Agregar comida",
    createdFirstMeal: "Crear primera comida",
    pleaseUpdateMenu: "Has creado con éxito tu primera comida, por favor haz clic aquí para actualizar tu menú después de configurar completamente tus comidas.",
    pleaseCreateSession: "Por favor procede a [Vista de cajero] para crear tu primera sesión/mesa.",
    storeSetupComplete: "Configuración de la tienda completada con éxito",
    moreStoreConfiguration: "Presiona el código QR para comenzar a tomar pedidos, o imprime el código QR para que tus clientes hagan pedidos. Procede a la sección [Configuraciones] para actualizar configuraciones específicas de la tienda para que coincidan perfectamente con la operación de tu tienda.",
    ok: "De acuerdo",
    features: "Características",
    others: "Otros",
    kitchen: "Vista de cocina",
    hasBeen: "ha sido",
    enabled: "activado",
    disabled: "desactivado",
    untickToDisable: "Desmarcar para desactivar",
    printAfterCompletion: "Imprimir después de completar el pedido",
    userDecide: "El usuario decide",
    alreadyAMember: "¿Ya eres miembro?",
    sign_up: "Registrarse",
    log_in: "Iniciar sesión",
    password: "Contraseña",
    confirmPassword: "Confirmar contraseña",
    passwordMustBe6: "La contraseña debe tener al menos 6 caracteres",
    required: "Requerido",
    passwordUnmatched: "Contraseña no coincidente",
    forgotPassword: "¿Olvidaste tu contraseña?",
    OR: "O",
    signInWithGoogle: "Iniciar sesión con Google",
    forgotPasswordInfo: "Recibirás un correo con un enlace para restablecer",
    resetPassword: "Restablecer contraseña",
    verifyYourEmail: "Verifica tu correo electrónico",
    check: "Revisa",
    toVerify: "para verificar tu cuenta y comenzar.",
    ifYouHaveNotReceived: "Si no has recibido el correo después de unos minutos, por favor revisa tu carpeta de spam",
    resendVerificationEmail: "Reenviar correo de verificación",
    refresh: "Refrescar",
    startNow: "Comenzar ahora",
    freeUnlimitedUsers: "Gratis. Usuarios ilimitados.",
    etilhubDescription: "Una solución POS ligera para gestionar tu restaurante y negocio de F&B de manera eficiente.",
    cloudSmart: "Basado en la nube | Inteligente",
    pointOfSale: "Punto de venta",
    registerForFree: "Registrarse gratis",
    qrFoodOrdering: "Pedidos de comida por QR",
    contactlessOrders: "Pedidos sin contacto",
    instantAndEasySetup: "Configuración instantánea y fácil",
    adjustableForEveryBusiness: "Ajustable para cada modelo de negocio de F&B",
    billingProcessingPrinting: "Procesamiento de facturación e impresión",
    orderSlipPrinting: "Impresión de comprobante de pedido",
    issueReceipt: "Emitir recibos impresos o electrónicos",
    sessionQRPrinting: "Impresión de código QR de sesión",
    instantKitchenView: "Vista de cocina instantánea",
    realtimeOrderStatus: "Estado del pedido en tiempo real",
    orderQueue: "Cola de pedidos",
    ingredientsDisplay: "Visualización de ingredientes",
    customizableFloorPlan: "Plano de piso personalizable",
    restaurantTableLayout: "Diseño de mesas de restaurante",
    realtimeTableStatus: "Estado de las mesas en tiempo real",
    intuitiveInterface: "Interfaz intuitiva",
    moreFeatures: "Más funciones",
    comingsoon: "Próximamente...",
    noItemExist: "No existen registros de ítems",
    myStore: "Mi tienda",
    logout: "Cerrar sesión",
    navigationSettings: "Configuraciones de navegación",
    navigateToPaymentAfterSubmit: "Navegar al pago después de enviar el pedido (Vista de cajero)",
    size: "Tamaño",
    small: "Pequeño",
    medium: "Mediano",
    large: "Grande",
    tableNameMustBeSame: "El nombre de la mesa debe ser el mismo que el de la sesión, puedes crear una mesa aquí primero antes de proceder a crear una sesión para tu tienda.",
    confirmDeleteStore: "Confirmar que deseas eliminar esta tienda escribiendo su nombre:",
    deleteThisStore: "¿Eliminar esta tienda?",
    deleteStoreWarning: "Hacerlo eliminará permanentemente la tienda y no podrá recuperarse en el futuro.",
    pleaseInsertStoreName: "Por favor, introduce el nombre de la tienda",
    cloneThisStore: "Clonar esta tienda",
    cloneStoreInfo: "Actualizar detalles para tu nueva tienda.",
    addIngredient: "Agregar ingrediente",
    orderUpdatedAt: "Pedido actualizado en la mesa",
    simpleMenuInfo: "Nota: El menú simple tiene una limitación de seleccionar múltiples opciones para cada comida.",
    fiverr: "Fiverr",
    bySigningUp: "Al registrarte, aceptas nuestros",
    privacyPolicy: "Política de privacidad",
    termsAndConditions: "Términos y condiciones",
    and: "y",
    storeExceedSubscriptionLimit: "El número de tiendas supera el límite de la suscripción, actualiza tu plan para agregar más tiendas.",
    someStoreIsNotShowing: "Algunas tiendas no se muestran debido a la expiración de tu suscripción.",
    currentPeriodStart: "Inicio del período actual",
    currentPeriodEnd: "Tu plan se renueva el",
    planCanceledOn: "Tu plan será cancelado el",
    storeQuantity: "Cantidad de tiendas",
    dailyOrder: "Límite de pedidos diarios",
    perStore: "por tienda",
    createdBy: "Creado por",
    completedBy: "Completado por",
    monday: "Lunes",
    tuesday: "Martes",
    wednesday: "Miércoles",
    thursday: "Jueves",
    friday: "Viernes",
    saturday: "Sábado",
    sunday: "Domingo",
    morePrices: "Más precios en Opciones",
    moreIngredients: "Más ingredientes en Opciones",
    all_: "Todo",
    filter: "Filtrar",
    expired: "Expirado",
    updated: "Actualizado",
    limitTime: "Tiempo límite",
    limitDay: "Día límite",
    outOfStock: "Agotado",
    startFrom: "Comienza desde",
    endAt: "Termina en",
    hour: "Hora",
    hours: "Horas",
    default: "Predeterminado",
    cloud: "Nube",
    printMethod: "Método de impresión",
    sessionCreated: "Sesión creada",
    orderCreated: "Pedido creado",
    event: "Evento",
    eventDescription: "Todos los botones de impresión (por ejemplo, Imprimir sesión, Imprimir comprobante de pedido, Imprimir comprobante de cocina, Imprimir recibo) activarán el evento de webhook por defecto. Selecciona cualquier tipo adicional de eventos para activar webhooks",
    endPointDescription: "Ingresa la URL en la que deseas recibir los webhooks",
    webhookDescription: "Enviaremos una solicitud POST a esta URL con un objeto JSON que representa los datos del evento para cualquier evento que elijas activar",
    testEndpointUrl: "Probar URL del punto final",
    failedToPrint: "Falló la impresión",
    secretKeyDescription: "La clave secreta se utilizará para firmar con el cuerpo HTTP utilizando HMAC-SHA256 y se incluirá en el encabezado llamado X-Hub-Signature",
    outGoingWebhooks: "Webhooks salientes",
    urlIsRequired: "La URL es requerida",
    invalidUrl: "URL inválida",
    endpointUrl: "URL del punto final",
    addWebhook: "Agregar Webhook",
    confirmDeleteWebhook: "¿Confirmar eliminación de webhook?",
    printButtonClick: "Cocina",
    takeOrderforTable: "Tomar pedido",
    addGuestNumber: "Agregar número de invitado",
    customerScreen: "Pantalla del cliente",
    orderHistory: "Historial de pedidos",
    endSession: "Finalizar sesión",
    orderNow: "Ordenar ahora",
    viewMenu: "Ver menú",
    adults: "Adultos",
    kids: "Niños",
    seniors: "Ancianos",
    other: "Otros",
    all: "Todo",
    leaveWarning: "¿Estás seguro de que quieres irte? Los cambios que has realizado podrían no guardarse.",
    personAtTable: "Personas ordenando en la mesa",
    bePatient: "Por favor, ten paciencia.",
    checkMenu: "Por favor, revisa el menú.",
    transferOwnership: "Transferir propiedad",
    cloneItem: "Clonar artículo",
    transferOwnershipToast: "Propiedad transferida con éxito",
    language: "Idioma",
    itemPrintName: "Nombre del artículo para impresión",
    serviceFee: "Tarifa de servicio",
    salesReport: "Informe de ventas",
    chatPrint: "Imprimir chat",
    send: "Enviar",
    openChatPrint: "Abrir impresión de chat",
    deleteCategory: "Eliminar categoría",
    deleteCategoryConfirmation: "¿Está seguro de que desea eliminar esta categoría?",
    categoryName: "Nombre de la categoría",
    deleteCategoryWarning: "Advertencia: esta acción no se puede deshacer",
    cannotDeleteCategoryWithItems: "No se puede eliminar una categoría que contiene artículos",
    totalItems: "Total de artículos",
    itemsInCategory: "Artículos en la categoría",
    pleaseRemoveItemsFirst: "Por favor, elimine primero los artículos",
    deletionFailed: "Eliminación fallida",
    categoryDeleted: "Categoría eliminada",
    categorySuccessfullyDeleted: "Categoría eliminada con éxito",
    errorDeletingCategory: "Error al eliminar la categoría",
    anErrorOccurred: "Ocurrió un error",
    categoryAll: "Todos",
    languageSettings: "Configuración de idioma",
    selectLanguagePopupInfo: "Por favor, elija el idioma que desea mostrar en la ventana emergente de inicio, pero necesita obtener el idioma de cada plato cargado en el sistema.",
    languagePopupEnabled: "Habilitar ventana emergente de idioma",
    languageChoiceActive: "Elección de idioma activa",
    selectLanguage: "Seleccionar idioma",
    languageChoiceUpdated: "Elección de idioma actualizada a",
    loadingSession: "Cargando sesión...",
    sessionInvalid: "Sesión inválida",
    loadingMenu: "Cargando menú...",
    enterYourName: "Introduzca su nombre",
    continue: "Continuar",
    othersOrdering: "¡Bienvenido a unirse!",
    nameRequired: "Nombre requerido",
    pleaseEnterName: "Por favor, introduzca su nombre para continuar",
    error: "Error",
    somethingWentWrong: "Algo salió mal",
    welcomeBack: "Bienvenido de nuevo",
    pleaseWait: "Por favor, espere",
    sessionCheckInProgress: "Comprobación de sesión en curso",
    noSuchTable: "Lo sentimos, ¡no existe esa mesa!",
    waitingForStaff: "Esperando a que el personal abra la mesa para usted ...",
    scanQRCodeAgain: "¡Por favor, escanee el código QR nuevamente para ordenar o acceder al menú!",
    bonAppetit: "¡Buen provecho!",
    modalSelectLanguage: "Seleccionar idioma",
    sessionNotProvided: "No se proporcionó sesión",
    noStoreIdProvided: "No hay ID de tienda en la sesión",
    storeNotConfigured: "Tienda no encontrada",
    failedToLoadData: "Error al cargar datos",
    orderNumber: "Pedido #",
    orderCreated: "Creado",
    orderTotal: "Total del pedido",
    totalWithTaxes: "Total con impuestos",
    customerName: "Nombre",
    totalFor: "Total para",
    noOrders: "Sin pedidos",
    grandTotal: "Total general",
    pastOrders: "Pedidos anteriores",
    poweredBy: "Desarrollado por",
    closeButton: "Cerrar",
    thisSelectionIsRequired: "Esta selección es obligatoria",
    pleaseSelectAtLeast: "Por favor, seleccione al menos",
    maximumSelections: "Máximo",
    selectionsAllowed: "selecciones permitidas",
    optionItems: "opciones",
    customizeYourOrder: "Personalice su pedido",
    totalExtra: "Extra total",
    cancelButton: "Cancelar",
    addToCart: "Añadir al carrito",
    selectExactly: "Debe seleccionar exactamente",
    singleItem: "elemento",
    selectRange: "Seleccione",
    rangeTo: "a",
    selectAtLeast: "Seleccione al menos",
    selectUpTo: "Seleccione hasta",
    selectMultipleOptional: "Selección múltiple (Opcional)",
    selectOneRequired: "Seleccione uno (Obligatorio)",
    requiredOption: "Obligatorio",
    invalidStoreId: "ID de tienda inválido",
    tableRedirectStoreNotFound: "Tienda no encontrada",
    tableRedirectError: "Algo salió mal. Por favor, inténtalo de nuevo.",
    loadingTable: "Buscando tu mesa...",
    fixedTableQrDisabled: "Los códigos QR de mesa fija están deshabilitados para esta tienda.",
    contactStaffForHelp: "Por favor, contacta al personal para obtener ayuda"
  };